var global = require('../internals/global');

module.exports = global;



//////////////////
// WEBPACK FOOTER
// /home/runner/work/slipresistant/slipresistant/client/~/core-js/internals/path.js
// module id = JmVy
// module chunks = 0 3